webpackJsonp([29],{

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(924),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(108);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // common
      sbar: false,
      sbarMsg: '',
      sbarCol: 'info',
      handy: __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a,
      beingSaved: false,
      show: false,
      // admins
      joinReq: [],
      tasks: '',
      // complaints
      totMine: 0,
      totOpenComp: 0,
      totNewComp: 0,
      totCritComp: 0,
      totPersComp: 0,
      // fm
      statDay: 'today',
      attend: '',
      dailyUpdate: '',
      assets: '',
      incidents: '',
      totalLikes: [],
      totalPinned: [],
      totalComment: [],
      showDateList: false,
      dateHeader: [{ text: 'Dates', values: 'selected_date' }],
      dlgHowToResDir: false,
      dlgHowToSecGaurd: false,
      dlgHowToiPhone: false,
      commSetupScore: { subscription: {}, setup_score: {} },
      isCommSetupPend: false,
      isMobAdminUser: true,
      dlgCommSetup: false
    };
  },

  computed: {
    today: function today() {
      return __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(Date());
    },
    nextThreeDays: function nextThreeDays() {
      var curDt = new Date();
      curDt.setDate(curDt.getDate() + 3);
      return __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(curDt);
    },
    totDlgNotice: function totDlgNotice() {
      if (this.notices.length) {
        this.dlgNotice = true;
      } else {
        this.dlgNotice = false;
      }
      return this.notices.length;
    }
  },
  created: function created() {
    this.refreshDashboard();
  },

  watch: {
    '$route': function $route(to, from) {
      this.refreshDashboard();
      this.$forceUpdate();
    }
  },
  methods: {
    msg: function msg(m) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.sbarCol = isError ? 'error' : 'success';
      this.sbar = true;
      this.sbarMsg = m;
    },
    refreshDashboard: function refreshDashboard() {
      // note: all these methods are asyncronous and will be loaded independantly
      this.loadIsMobAdminUser();
      if (__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.UNIT_ID_LIST.length || __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_ADMIN) {
        this.loadJoinReq();
      }
      this.loadComps();
      this.loadTasks();
      if (__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_OTHER_USER) {
        this.loadStatsForStaffDashboard();
      }
    },
    cancelReq: function cancelReq(curUnit) {
      var _this = this;

      if (confirm('Sure, you want to cancel the request?')) {
        var req = {
          unit_id: curUnit.unit_id,
          cust_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.CUST_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          is_other_user: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_OTHER_USER
        };
        this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/admin/cancel-req', req).then(function (response) {
          // refresh list in front end
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* logout */])();
        }).catch(function (err) {
          _this.msg(err.response.data, true);
        });
      }
    },
    logout: function logout() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* logout */])();
    },
    loadTasks: function loadTasks() {
      var _this2 = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getOpenTaskSummaryByUserId/', qry).then(function (response) {
        _this2.tasks = response.data[0];
      });
    },
    loadComps: function loadComps() {
      var _this3 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID
        }
        // users complaints (created by / assigned to this user)
      };this.totMine = 0;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getComplaintsByUser/', qry).then(function (response) {
        _this3.totMine = response.data.length;
      });
      // all open complaints
      this.totOpenComp = 0;
      this.totNewComp = 0;
      this.totCritComp = 0;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getComplaintsByComm/', qry).then(function (response) {
        _this3.totOpenComp = response.data.length;
        _this3.totNewComp = response.data.filter(function (rec) {
          return rec.comp_status === 'New';
        }).length;
        _this3.totCritComp = response.data.filter(function (rec) {
          return rec.comp_severity === 'Critical';
        }).length;
      });
    },
    loadIsMobAdminUser: function loadIsMobAdminUser() {
      var _this4 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID
        }
        // load joining request of new user for the particular community
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getIsMobileAdminUser/', qry).then(function (response) {
        _this4.isMobAdminUser = response.data.length;
      }).catch(function (err) {
        _this4.msg(err.response.data, true);
      });
    },
    loadJoinReq: function loadJoinReq() {
      var _this5 = this;

      var qry = {
        params: {
          unit_id_list: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.UNIT_ID_LIST,
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          is_admin: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.IS_ADMIN,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID
        }
        // load joining request of new user for the particular community
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getJoiningRequest/', qry).then(function (response) {
        _this5.joinReq = response.data;
      }).catch(function (err) {
        _this5.msg(err.response.data, true);
        _this5.joinReq = [];
      });
    },
    loadStatsForStaffDashboard: function loadStatsForStaffDashboard() {
      var _this6 = this;

      var statDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.statDay;

      this.statDay = statDay;
      var statDate = this.today;
      if (statDay === 'yesterday') {
        var curDate = new Date();
        statDate = __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDBDate(curDate.setDate(curDate.getDate() - 1));
      }
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_ID,
          user_id: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.USER_ID,
          stat_dt: statDate
        }
        // all open complaints
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getComplaintsByComm/', qry).then(function (response) {
        _this6.totOpenComp = response.data.length;
        _this6.totNewComp = response.data.filter(function (rec) {
          return rec.comp_status === 'New';
        }).length;
        _this6.totCritComp = response.data.filter(function (rec) {
          return rec.comp_severity === 'Critical';
        }).length;
      });
      // attendace
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getAttendanceStat/', qry).then(function (response) {
        _this6.attend = response.data;
      });
      // daily update
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getDailyUpdateStat/', qry).then(function (response) {
        _this6.dailyUpdate = response.data;
      });
      // asset
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getAssetsForAMCDue/', qry).then(function (response) {
        _this6.assets = response.data;
      });
      // incidents
      qry.params.incident_status = 'Open';
      qry.params.as_on = qry.params.stat_dt;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getIncidentsByCommId/', qry).then(function (response) {
        _this6.incidents = response.data;
      });
    }
  }
});

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.config.IS_USER_ACTIVE) ? _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "info text-xs-center",
    attrs: {
      "value": "true"
    }
  }, [_vm._v("\n              Access is currently denied for your account\n              "), _c('br'), _c('br'), _vm._v("\n              Please contact your Community Admin / Integra Back Office to grant access.\n            ")])], 1)], 1)], 1)], 1) : (_vm.config.IS_USER_ACTIVE && _vm.config.ALL_UNITS.findIndex(function (rec) { return rec.rel_status !== 'Linked'; }) >= 0) ? _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.config.ALL_UNITS.filter(function (rec) { return rec.rel_status !== 'Linked'; })), function(unit, i) {
    return _c('span', {
      key: i,
      staticClass: "text-xs-center",
      attrs: {
        "color": "info",
        "value": "true"
      }
    }, [(unit.rel_status === 'Pending Approval') ? _c('v-alert', [_vm._v("\n                Your joining request for "), _c('span', {
      staticClass: "subheading yellow--text"
    }, [_vm._v(_vm._s((unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + _vm.config.COMM_NAME))]), _vm._v(" is yet to be approved by your community admin.\n                "), _c('br'), _c('br'), _vm._v("\n                It may take few hours to process your request and you will be notified as soon as it is done.\n                "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": _vm.logout
      }
    }, [_vm._v("Logout")])], 1)]) : (unit.rel_status === 'Rejected') ? _c('v-alert', [_vm._v("\n                Your joining request for "), _c('span', {
      staticClass: "yellow--text"
    }, [_vm._v(_vm._s(unit.block_nm + ' ' + unit.unit_no))]), _vm._v(" was rejected with below reason.\n                "), _c('div', {
      staticClass: "text-xs-center white--text mt-2"
    }, [_vm._v("\n                  \"" + _vm._s(unit.rej_reason) + "\"\n                ")]), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": function($event) {
          return _vm.cancelReq(unit)
        }
      }
    }, [_vm._v("Cancel & Sign-up again")])], 1)]) : (unit.rel_status === 'Delinked' && _vm.config.ALL_UNITS.length === 1) ? _c('v-alert', [_vm._v("\n                You are currently delinked from "), _c('span', {
      staticClass: "yellow--text"
    }, [_vm._v(_vm._s((unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + _vm.config.COMM_NAME))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Please contact your Community Admin / Integra Back Office if you did not expect to see this message.\n                "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": _vm.logout
      }
    }, [_vm._v("Logout")])], 1)]) : _vm._e()], 1)
  }), 0)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.IS_USER_ACTIVE && _vm.config.UNITS.findIndex(function (rec) { return rec.rel_status === 'Linked'; }) >= 0) ? _c('div', [_c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.joinReq.length) ? _c('v-flex', {
    staticClass: "pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": {
        path: (_vm.config.IS_ADMIN ? '/users' : '/profile/join')
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading primary lighten-2 white--text"
  }, [_vm._v("\n                Joining Requests\n              ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.joinReq.length + ' request' + (_vm.joinReq.length > 1 ? 's' : '')) + " pending for your review!")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobAdminUser) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading primary lighten-2 white--text"
  }, [_vm._v("\n            Welcome to Integra Admin!\n          ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-1"
  }, [_vm._v("\n            Do you know, you can access this Integra App in your mobile phone as well?\n            "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_vm._v("\n                Android\n                "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=in.smartility.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    }
  }, [_c('img', {
    attrs: {
      "width": "150",
      "alt": "Get it on Google Play",
      "src": "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
    }
  })])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_vm._v("\n                iPhone\n                "), _c('div', {
    staticClass: "pa-2"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.dlgHowToiPhone = true
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "Install web app",
      "width": "140",
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/pwa_app.png'
    }
  })])])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tasks) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center warning",
    attrs: {
      "to": {
        path: '/task'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("group_work")]), _vm._v("Task\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pt-0 pb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.tasks.tot_task) + "\n            "), (_vm.tasks.past_due) ? _c('v-chip', {
    staticClass: "error white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.past_due + ' past due'))]) : _vm._e(), _vm._v(" "), (_vm.tasks.due_today) ? _c('v-chip', {
    staticClass: "warning white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.due_today + ' due today'))]) : _vm._e(), _vm._v(" "), (_vm.tasks.pend_appr) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.pend_appr + ' for your approval'))]) : _vm._e()], 1)], 1)], 1) : (_vm.tasks) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center primary lighten-2 white--text",
    attrs: {
      "to": {
        path: '/task'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("group_work")]), _vm._v("Task\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_vm._v("\n            " + _vm._s(_vm.tasks ? _vm.tasks.tot_task : 0) + "\n            "), (_vm.tasks && _vm.tasks.past_due) ? _c('v-chip', {
    staticClass: "error white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.past_due + ' past due'))]) : _vm._e(), _vm._v(" "), (_vm.tasks && _vm.tasks.due_today) ? _c('v-chip', {
    staticClass: "warning white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.due_today + ' due today'))]) : _vm._e(), _vm._v(" "), (_vm.tasks && _vm.tasks.pend_appr) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.pend_appr + ' for your approval'))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 primary lighten-2"
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("engineering")]), _vm._v("Facility Management\n            "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    class: 'caption ml-0 mr-1 black--text ' + (_vm.statDay === 'yesterday' ? 'primary lighten-5' : 'primary lighten-3'),
    attrs: {
      "small": "",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadStatsForStaffDashboard('yesterday')
      }
    }
  }, [_vm._v("yesterday")]), _vm._v(" "), _c('v-chip', {
    class: 'caption ma-0 black--text ' + (_vm.statDay === 'today' ? 'primary lighten-5' : 'primary lighten-3'),
    attrs: {
      "small": "",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadStatsForStaffDashboard('today')
      }
    }
  }, [_vm._v("today")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "to": {
        path: '/attendance'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("camera_front")]), _vm._v("Attendance\n                    "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/attendance'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                      " + _vm._s((_vm.attend.percent || 0) + '%')), _c('br'), _vm._v(" "), (_vm.attend.tot_pend) ? _c('v-chip', {
    staticClass: "red white--text",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.attend.tot_pend + ' pending'))]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("today")]), _vm._v("Daily Update\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showDateList = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/dailyupdate'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text",
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.dailyUpdate.c_date ? (_vm.dailyUpdate.is_sub_app || _vm.dailyUpdate.is_app ? 'Done' : 'Draft') : 'Pending') + " "), _c('br'), _vm._v(" "), (_vm.dailyUpdate.tot_pend) ? _c('v-chip', {
    staticClass: "red white--text caption",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.dailyUpdate.tot_pend + ' days pending'))]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "to": {
        path: '/inventory'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("category")]), _vm._v("Assets\n                    "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/inventory'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text",
    staticStyle: {
      "font-size": "26px"
    }
  }, [(_vm.assets.amc_past_due) ? _c('span', [_vm._v(_vm._s(_vm.assets.amc_past_due) + " "), _c('span', {
    staticClass: "red--text body-1"
  }, [_vm._v("AMC past due")]), _c('br')]) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.assets.amc_due_soon) + " "), _c('span', {
    class: 'body-1 ' + (_vm.assets.amc_due_soon ? 'red--text' : '')
  }, [_vm._v("AMC due soon")]), _vm._v(" "), (_vm.assets.tot_outside) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.assets.tot_outside + ' out for service'))]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "to": {
        path: '/incidents'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("report_problem")]), _vm._v("Incidents\n                    "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/incidents'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.incidents.length || 0) + "\n                    ")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dlgHowToiPhone),
      callback: function($$v) {
        _vm.dlgHowToiPhone = $$v
      },
      expression: "dlgHowToiPhone"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-1"
  }, [_vm._v("\n          How to install in iPhone?\n        ")]), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "mt-2"
  }, [_c('li', [_vm._v("\n              Open your safari browser\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Go to "), _c('a', {
    attrs: {
      "href": "https://app.integrafms.com",
      "target": "_blank"
    }
  }, [_vm._v("https://app.integrafms.com")])]), _vm._v(" "), _c('li', [_vm._v("\n              Tap on share icon at the bottom of your browser window\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Tap on \"Add to Home Screen\" to install the app\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "width": "85%",
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/pwa_install.png'
    }
  })])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgHowToiPhone = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showDateList),
      callback: function($$v) {
        _vm.showDateList = $$v
      },
      expression: "showDateList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title grey lighten-4"
  }, [_vm._v("\n      List Of FM Daily Update Pending dates\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDateList = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.dateHeader,
      "items": _vm.dailyUpdate.dateList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.selected_date)))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center mt-4",
    staticStyle: {
      "opacity": "0.25"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "height": "100",
      "width": "250",
      "src": _vm.config.STATIC_FILES_DIR + '/img/logo/integra_logo.png'
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.c0d1c417b5673eea1bc5.js